module fdm.aircrafts {

    angular.module('fdm.aircrafts', []);
}